import script from "./Wall.vue?vue&type=script&setup=true&lang=js"
export * from "./Wall.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__